// 校验手机号
function isPoneAvailable(pone) {
    if (!(/^1[3456789]\d{9}$/.test(pone))) {
        return false;
    }
}
// 校验身份证号格式
function idCode(val) {
    var regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!regIdNo.test(val)) {
        return false;
    }else{
        return true
    }
}

// 多维数组转换为一维数组
function flatten(sourceArray, flattenedArray = []) {
	for (const element of sourceArray) {
		if (Array.isArray(element)) {
			flatten(element, flattenedArray);
		} else {
			flattenedArray.push(element);
		}
	}
	return flattenedArray;
}

// const arr = [
// 	[0], 1, 2, [3, [4, 5]], 6
// ];
// console.log(flatten(arr))
// 校验手机号
function phoneCheck(phoneVal) {
	var reg = /^1[3|4|5|7|8][0-9]{9}$/;
	if (reg.test(phoneVal)) {
		return true
	} else {
		return false
	}
}
// 校验邮箱
function emailCheck(emailVal) {
	var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
	if (reg.test(emailVal)) {
		return true
	} else {
		return false
	}
}
// 校验身份证号
function isCardNo(card) {
	var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	if (reg.test(card)) {
		return true
	} else {
		return false
	}
}

// 比较开始时间不能大于结束时间
function tabTime(date1, date2) {
	var oDate1 = new Date(date1);
	var oDate2 = new Date(date2);
	if (oDate1.getTime() < oDate2.getTime()) {
		return true
	} else {
		return false
	}
}
// console.log(tabTime('2015-10-12','2015-10-11'))
// 两个时间相差多少天
function daysBetween(sDate1, sDate2) {
	//Date.parse() 解析一个日期时间字符串，并返回1970/1/1 午夜距离该日期时间的毫秒数
	var time1 = Date.parse(new Date(sDate1));
	var time2 = Date.parse(new Date(sDate2));
	var nDays = Math.abs(parseInt((time2 - time1) / 1000 / 3600 / 24));
	return nDays;
}

// 获取七天后的时间
function sevenData() {
    var now = new Date();
    var date = new Date(now.getTime() + 7 * 24 * 3600 * 1000);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    month = JSON.stringify(month)
    day = JSON.stringify(day)
    if (month.length < 2) {
        month = "0" + month
    }
    if (day.length < 2) {
        day = "0" + day
    }
    return year + '-' + month + '-' + day;
}
// console.log(daysBetween('2016-11-01 20:10:10','2016-11-02 20:10:15'));

function TimeDifference(Stime, Ttime) {
	//判断开始时间是否大于结束日期
	if (Stime > Ttime) {
		console.log("开始时间不能大于结束时间！");
		return false;
	}
	if (Ttime && Stime) {
		var startDate = new Date(Stime);
		var stopDate = new Date(Ttime);
		var startTime = startDate.getTime();
		var stopTime = stopDate.getTime();
		var cTime = Number(stopTime) - Number(startTime);
		var secondTime = cTime / 1000 / 60;
		return parseInt(secondTime);
	} else {
		return 0;
	}

}
//Stime ：开始时间  Ttime:结束时间
// console.log(TimeDifference("2020-03-11 10:22:22", "2020-03-11 10:29:22"));
// 校验url地址
function isUrl(val) {
	var rex = /^(http|https){1}:\/\/[^\s]+$/;
	if (rex.test(val)) {
		return true
	} else {
		return false
	}
}
// 判断一个对象是否存在空
// 第一个参数传递所有的数据  ，第二个参数传递忽略不校验的键一个数组
function empty(emptyObj, ignoreArr) {
	var ignoreArr = JSON.stringify(ignoreArr)
	for (let key in emptyObj) {
		if (ignoreArr.indexOf(key) == -1) {
			if (emptyObj[key] == '') {
				return false
			} else {
				continue
			}
		} else {
			continue
		}
	}
	return true
}
// 校验身份证号码
function checkIdcard(personnumber) {
    personnumber = personnumber.toUpperCase();
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(personnumber))) {
        return false;
    }
    //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    //下面分别分析出生日期和校验位
    var len, re;
    len = personnumber.length;
    if (len == 15) {
        re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit = personnumber.match(re);

        //检查生日日期是否正确
        var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
            return false;
        }
        else {
            //将15位身份证转成18位
            //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
            var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
            var nTemp = 0, i;
            personnumber = personnumber.substr(0, 6) + '19' + personnumber.substr(6, personnumber.length - 6);
            for (i = 0; i < 17; i++) {
                nTemp += personnumber.substr(i, 1) * arrInt[i];
            }
            personnumber += arrCh[nTemp % 11];
            return true;
        }
    }
    if (len == 18) {
        re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        var arrSplit = personnumber.match(re);

        //检查生日日期是否正确
        var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
        var bGoodDay;
        bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
        if (!bGoodDay) {
            return false;
        } else {
            //检验18位身份证的校验码是否正确。
            //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
            var valnum;
            var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
            var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
            var nTemp = 0, i;
            for (i = 0; i < 17; i++) {
                nTemp += personnumber.substr(i, 1) * arrInt[i];
            }
            valnum = arrCh[nTemp % 11];
            if (valnum != personnumber.substr(17, 1)) {
                return false;
            }
            return true;
        }
    }
    return false;
}


function copyText(text){
    var textareaC = document.createElement('textarea');
    textareaC.setAttribute('readonly', 'readonly');
    textareaC.value = text;
    document.body.appendChild(textareaC);
    textareaC.select();
    var res = document.execCommand('copy');
    document.body.removeChild(textareaC);
    return res;
}


export {
    isPoneAvailable,
    idCode,
    flatten,
    phoneCheck,
    emailCheck,
    isCardNo,
    tabTime,
    daysBetween,
    sevenData,
    TimeDifference,
    isUrl,
    empty,
	checkIdcard,
    copyText
}
